import Vue from 'vue'
import domains from '_static/domains.json'
import { inLocalEnv, country, environment } from '@/helpers/global.helpers'
import signalrRepository from '@/repositories/SignalrRepository'
import * as signalR from '@microsoft/signalr'
import { NOTIFICATION_TYPE_COMMANDS } from '@/constants/signalRCommands'

const HUB = 'hub'
const HUB_URL = `${inLocalEnv ? domains.apis.api.local : domains.apis.api[country][environment]}/${HUB}`
const RECEIVER_COMMAND = 'ReceiveMessage'
const SENDER_COMMAND = 'SendMessageToClient'

const signalRStore = {
	namespaced: true,
	state: {
		socket: null,
		commandsHistory: [],
		commandReceived: null,
	},
	mutations: {
		setCommandReceived (state, payload) {
			state.commandReceived = payload
			state.commandsHistory = [...state.commandsHistory, payload]
		}
	},
	actions: {
		async init ({ dispatch, state }) {
			if (state.socket) {
				return
			}
			state.socket = new signalR.HubConnectionBuilder().configureLogging(signalR.LogLevel.Error).withUrl(`${HUB_URL}?token=${Vue.prototype.$apiToken}`).build()
			return state.socket.start().then(() => {
				state.socket.on(RECEIVER_COMMAND, ({ command, data, signalRId }) => {
					dispatch('onCommandReceived',  { command: command, data, signalRId })
				})
			})
		},
		async sendCommand ({ dispatch, state }, { userId, message }) {
			if (!state.socket) {
				await dispatch('init')
			}
			state.socket.invoke(SENDER_COMMAND, userId, message)
		},
		onCommandReceived ({ commit, dispatch }, payload) {
			signalrRepository.setSignalrMessageState(payload.signalRId)
			commit('setCommandReceived', payload)
			if (NOTIFICATION_TYPE_COMMANDS.includes(payload.command)) {
				dispatch('notifications/onNewNotification', { id: payload.command, data: payload.data, signalRId: payload.signalRId }, { root: true })
			}
		}
	}
}

export default signalRStore


// WEBPACK FOOTER //
// ./src/store/modules/signalr.js